import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Frame = styled.img`
  position: absolute;
`;
Frame.displayName = 'Frame';

export const FrameContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;
FrameContainer.displayName = 'FrameContainer';

export const Logo = styled.img`
  bottom: -59px;
  position: absolute;
  transform: translateX(5px);
`;
Logo.displayName = 'Logo';

export const Time = styled.div`
  align-items: center;
  background: #3e2d19;
  color: #ffffff;
  display: flex;
  font-family: 'Passion One', cursive;
  font-size: 90px;
  height: 168px;
  justify-content: center;
  letter-spacing: 2px;
  line-height: 64px;
  min-width: 285px;
  text-align: center;
  text-decoration: inherit;
  width: 432px;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #ffffff;
  font-size: 48px;
  font-family: 'Passion One', cursive;
  letter-spacing: 2px;
  line-height: 40px;
  letter-spacing: 0px;
  margin-bottom: 8px;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
